import { UserDataService } from './../../../data/repository/user-repository/user-data.service';
import { User } from './../../../core/model/user-model';
import { BlogUserModel } from './../../../core/model/object/blog-user-model';
import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { BlogUserService } from 'src/app/data/repository/blog-repository/blog-user.service';
import { BlogShared } from '../../general/shared/blog-shared';
import { BottomsheetShared } from '../../general/shared/bottomsheet-shared';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { LoadingShared } from '../../general/shared/loading-shared';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { TextHelper } from 'src/app/utils/text-helper';
import { TribuneAnalyticsService } from 'src/app/data/repository/analytics-repository/tribune-analytics.service';
import { ReportBottomsheetModel } from '../../general/report-bottomsheet/report-bottomsheet.component';
import { Subscription } from 'rxjs';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';

@Component({
  selector: 'app-blog-setting',
  templateUrl: './blog-setting.component.html',
  styleUrls: ['./blog-setting.component.scss'],
})
export class BlogSettingComponent implements OnInit, OnDestroy {
  @Input() id: number = 10;
  @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;

  element: any;
  isActive = true;

  blogUser: BlogUserModel;
  user: User;

  dataIsReady = false;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  base64 = '';

  showProfile = false;
  profileId = 10;
  selectedUsername = '';

  selectedType: string;
  showEdit = false;
  showCropImage = false;
  showBottomsheet = false;
  bottomsheetData: ReportBottomsheetModel;

  profileTitles = [
    'نام',
    'نام کاربری',
    'درباره من',
    'وضعیت صفحه',
    'حساب‌های کاربری مسدود شده',
  ];
  profileValues = ['', '', '', '', ''];
  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  subscription5: Subscription;
  subscription6: Subscription;

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // this.showLoading = false;
    // cropper ready
  }
  loadImageFailed() {
    // this.showLoading = false;
    // show message
  }
  constructor(
    private blogUserService: BlogUserService,
    private blogShared: BlogShared,
    private bottomsheetShared: BottomsheetShared,
    private blogService: BlogService,
    private loadingShared: LoadingShared,
    private snackBarService: SnackBarService,
    private textHelper: TextHelper,
    private tribuneAnalytics: TribuneAnalyticsService,
    private userDataService: UserDataService
  ) {
    this.blogUserService.getBlogUser().then((res) => {
      this.blogUser = res;
      this.prepare();
    });

    this.subscription1 =
      this.bottomsheetShared.closeReportBottomsheetObs$.subscribe((close) => {
        if (close) {
          this.showBottomsheet = false;
        }
      });
    this.subscription2 = this.blogShared.openBlogImageCropperObs$.subscribe(
      (show) => {
        if (show) {
          this.showBottomsheet = false;
          this.openCropImageView();
        }
      }
    );
    this.subscription3 = this.blogShared.deleteBlogImageObs$.subscribe(
      (del) => {
        if (del) {
          this.deleteImage();
        }
      }
    );
    this.subscription4 = this.bottomsheetShared.closeBottomsheetObs$.subscribe(
      (close) => {
        if (close) {
          this.showEdit = false;
        }
      }
    );
    this.subscription5 =
      this.bottomsheetShared.closeAndUpdateBottomsheetObs$.subscribe(
        (close) => {
          if (close) {
            this.prepare();
            this.showEdit = false;
          }
        }
      );
    this.subscription6 = this.blogShared.openProfileObs$.subscribe((open) => {
      if (open) {
        this.profile(this.blogShared.getSelectedUsername());
      }
    });
  }

  ngOnInit() {}

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
    this.subscription5.unsubscribe();
    this.subscription6.unsubscribe();
  }

  prepare() {
    this.loadingShared.showLoading();
    this.userDataService.getUser().then((result) => {
      if (result) {
        this.user = result;
        this.profileValues[0] = result.name;
        this.blogUserService.getBlogUser().then((res) => {
          this.blogUser = res;
          // console.log(res)
          this.profileValues[0] = res.name;
          this.profileValues[1] = res.userName;
          this.profileValues[2] = res.bio;
          this.profileValues[3] = res.status === 'public' ? 'عمومی' : 'خصوصی';
          this.profileValues[4] = '';

          this.loadingShared.hideLoading();
          this.dataIsReady = true;
        });
      }
    });
  }

  profile(username: string) {
    this.blogService.goToUserProfile(username);
    // this.selectedUsername = username;
    // this.blogShared.blogZIndex++;
    // this.profileId = this.blogShared.blogZIndex;
    // this.showProfile = true;
    // setTimeout(() => {
    //   document.getElementById('profilePage' + this.id).style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('profilePage' + this.id).style.right = '0';
    // }, 100);
  }

  closeProfile() {
    this.blogService.goback();
    // this.blogShared.blogZIndex--;
    // document.getElementById('profilePage' + this.id).style.right = '100%';
    // // this._sharedService.animateDownButton();
    // setTimeout(() => {
    //   this.showProfile = false;
    // }, 300);
  }

  openEdit(index: number) {
    switch (index) {
      case 0:
        this.selectedType = 'name';
        break;
      case 1:
        this.selectedType = 'username';
        break;
      case 2:
        this.selectedType = 'bio';
        break;
      case 3:
        this.selectedType = 'isPublic';
        break;
      case 4:
        this.selectedType = 'blocks';
        break;
    }
    this.showEdit = true;
  }

  deleteImage() {
    this.loadingShared.showLoading();
    this.blogService.editBlogUser(null, null, null, null, '').then((res) => {
      if (res.isSuccess()) {
        this.snackBarService.showSnackBar('عکس با موفقیت حذف شد.');
        this.blogUser.avatar = '';
        this.blogUser.avatarPath = '';
        this.showBottomsheet = false;
        this.tribuneAnalytics.analyticTribuneAvatarChanged('deleted');
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
      this.loadingShared.hideLoading();
    });
  }

  async saveImageProfile() {
    const result = await fetch(this.croppedImage);
    const blob = await result.blob();
    let payload = new FormData();
    payload.append('avatar', blob);
    this.loadingShared.showLoading();
    this.blogService.setBlogImage(payload, this.blogUser).then((res) => {
      if (res.isSuccess()) {
        if (this.blogUser.avatarPath === '') {
          this.tribuneAnalytics.analyticTribuneAvatarChanged('added');
        } else {
          this.tribuneAnalytics.analyticTribuneAvatarChanged('changed');
        }
        this.blogUserService.getBlogUser().then((response) => {
          this.snackBarService.showSnackBar('عکس با موفقیت ثبت شد.');
          this.blogUser = response;
          this.closeCropImage();
        });
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
      this.loadingShared.hideLoading();
    });
  }

  openImageBottomsheet() {
    let titles = [];
    if (this.blogUser.avatarPath !== '') {
      titles = ['تغییر عکس', 'حذف عکس'];
    } else {
      titles = ['انتخاب عکس'];
    }
    this.bottomsheetData = new ReportBottomsheetModel(
      'image',
      'تغییر وضعیت عکس',
      '',
      titles
    );
    this.showBottomsheet = true;
  }

  rotateLeft() {
    this.imageCropper.rotateLeft();
  }

  openCropImageView() {
    this.showCropImage = true;
    setTimeout(() => {
      document.getElementById('croppedImageView').style.right = '0';
    }, 100);
  }

  closeCropImage() {
    this.croppedImage = '';
    this.imageChangedEvent = '';
    document.getElementById('croppedImageView').style.right = '100%';
    setTimeout(() => {
      this.showCropImage = false;
    }, 300);
  }

  runLoading() {
    document.getElementById('file').click();
    // this.showLoading = true;
  }
}
